import React from 'react';
import { MEDIUM_OUTFIT } from '../constants';
import ModularGridGameTile from '../ModularGridGameTile';
import { GameClickProps, GameTileProps } from '../types';
import { WidgetTileGridProps } from './WidgetGrid';

import styles from './WidgetGrid.module.scss';

interface Dependencies {
  onClick: WidgetTileGridProps['onClick'];
  onInfoClick: WidgetTileGridProps['onInfoClick'];
  overlay?: WidgetTileGridProps['overlay'];
  gameDetailsInfo: WidgetTileGridProps['gameDetailsInfo'];
  gameInfoTooltip: WidgetTileGridProps['gameInfoTooltip'];
  categoryAttributes?: WidgetTileGridProps['categoryAttributes'];
  gamePosition: number;
  slot: GameTileProps;
  tileSize: 'large' | 'small';
}

export const TileSlot = ({
  onClick,
  onInfoClick,
  overlay,
  gameDetailsInfo,
  gameInfoTooltip,
  categoryAttributes,
  gamePosition,
  slot,
  tileSize,
}: Dependencies) => {
  const createClickHandler = (gamePosition: number, callback: Function) => (
    game: GameClickProps,
    path?: string
  ) => {
    callback({ game, gamePosition, ...(path && { path }) });
  };

  return (
    <div
      className={styles.gridSlot}
      data-testid={`${gamePosition}-slot`}
      key={`${gamePosition}-key`}
    >
      <ModularGridGameTile
        data-testid="modular-grid-tile"
        game={slot}
        onClick={createClickHandler(gamePosition, onClick)}
        onInfoClick={createClickHandler(gamePosition, onInfoClick)}
        outfit={MEDIUM_OUTFIT}
        isAnchor
        ghost={!!overlay}
        gameDetailsInfo={gameDetailsInfo}
        gameInfoTooltip={gameInfoTooltip}
        tileSize={tileSize}
        categoryAttributes={categoryAttributes}
      />
    </div>
  );
};
